import { use } from '@fegobull/webapi';
import { computed, ref, watch } from 'vue-demi';
import { FORBIDDEN_TYPE } from './constants';
import { Channel, Language } from './type';

const { useI18n } = use;

export const languageMap = {
    [Language.EN]: {
        mycode: 'My invite code',
        codeText: 'Invite code',
        copy: 'Copy',
        copySuccess: 'Copied',
        shareTo: 'Share to',
        names: {
            [Channel.SYSTEM]: 'More',
            [Channel.REDDIT]: 'Reddit',
            [Channel.FACEBOOK]: 'Facebook',
            [Channel.TELEGRAM]: 'Telegram',
            [Channel.XIAOHONGSHU]: 'REDnote',
            [Channel.TWITTER]: 'X',
            [Channel.INSTAGRAM]: 'Instagram',
            [Channel.WECHAT]: 'WeChat',
            [Channel.WECHAT_MOMENTS]: 'Moments'
        },
        sharePopupTitle: 'Choose an image to share',
        sharePopupImageLabel: 'Images（choose one）',
        sharePopupImageDownload: 'Save all images',
        sharePopupTextLabel: 'Share Content',
        sharePopupTextBtn: 'Change',
        sharePopupFillPrefix: 'Copy and share to {name}',
        uninstallPopupDescPrefix: `You don't have {name} installed`,
        uninstallPopupShare: 'Share link to other platforms',
        requestFail: 'Request Failed',
        shareTitle: 'EasyShare Pal',
        shareTip: 'Share Tips',
        shareIconText: 'Photo + Text',
        shareBtnText: 'Share to {name}',
        disclosure: 'Disclosure',
        bottomTextWhenToHome: '*Tap the button to copy text and save images',
        bottomTextWhenToEdit: '*Tap the button to copy text and fill images',
        forbidden: {
            desc: {
                [FORBIDDEN_TYPE.NOT_APP]: 'To join the event, please view it through the App',
                [FORBIDDEN_TYPE.LOW_VERSION]: 'Sorry. Only available for the latest version of the App.'
            },
            btn: {
                [FORBIDDEN_TYPE.LOW_VERSION]: 'Update App Now'
            }
        }
    },
    [Language.SC]: {
        mycode: '我的邀请码',
        codeText: '邀请码',
        copy: '复制',
        copySuccess: '复制成功',
        shareTo: '分享至',
        names: {
            [Channel.SYSTEM]: '更多',
            [Channel.REDDIT]: 'Reddit',
            [Channel.FACEBOOK]: 'Facebook',
            [Channel.TELEGRAM]: 'Telegram',
            [Channel.XIAOHONGSHU]: '小红书',
            [Channel.TWITTER]: 'X',
            [Channel.INSTAGRAM]: 'Instagram',
            [Channel.WECHAT]: '微信',
            [Channel.WECHAT_MOMENTS]: '朋友圈'
        },
        sharePopupTitle: '选择分享素材',
        sharePopupImageLabel: '分享图（单选）',
        sharePopupImageDownload: '下载全部图片',
        sharePopupTextLabel: '分享文案',
        sharePopupTextBtn: '换一套',
        sharePopupFillPrefix: '一键复制分享至{name}',
        uninstallPopupDescPrefix: '您尚未安装{name}',
        uninstallPopupShare: '分享链接至其他平台',
        requestFail: '请求失败',
        shareTitle: '快捷分享小助手',
        shareTip: '分享小贴士',
        shareIconText: '图片+文案',
        shareBtnText: '分享至{name}',
        disclosure: '相关披露文件',
        bottomTextWhenToHome: '*点击按钮可一键复制文字、保存图片',
        bottomTextWhenToEdit: '*点击按钮可一键复制文字、填充图片',
        forbidden: {
            desc: {
                [FORBIDDEN_TYPE.NOT_APP]: '本次活动需要在APP内查看',
                [FORBIDDEN_TYPE.LOW_VERSION]: '抱歉，需更新APP至最新版本后才能使用。'
            },
            btn: {
                [FORBIDDEN_TYPE.LOW_VERSION]: '立即更新'
            }
        }
    },
    [Language.TC]: {
        mycode: '我的邀請碼',
        codeText: '邀請碼',
        copy: '複製',
        copySuccess: '複製成功',
        shareTo: '分享至',
        names: {
            [Channel.SYSTEM]: '更多',
            [Channel.REDDIT]: 'Reddit',
            [Channel.FACEBOOK]: 'Facebook',
            [Channel.TELEGRAM]: 'Telegram',
            [Channel.XIAOHONGSHU]: '小红书',
            [Channel.TWITTER]: 'X',
            [Channel.INSTAGRAM]: 'Instagram',
            [Channel.WECHAT]: 'WeChat',
            [Channel.WECHAT_MOMENTS]: '朋友圈'
        },
        sharePopupTitle: '選擇分享素材',
        sharePopupImageLabel: '分享圖（單選）',
        sharePopupImageDownload: '下載全部圖片',
        sharePopupTextLabel: '分享文案',
        sharePopupTextBtn: '換一套',
        sharePopupFillPrefix: '一鍵複製分享至{name}',
        uninstallPopupDescPrefix: '您尚未安裝{name}',
        uninstallPopupShare: '分享鏈接至其他平台',
        requestFail: '請求失敗',
        shareTitle: '快捷分享小助手',
        shareTip: '分享小貼士',
        shareIconText: '圖片+文案',
        shareBtnText: '分享至{name}',
        disclosure: '相關披露文件',
        bottomTextWhenToHome: '*點擊按鈕可一鍵複製文字、保存圖片',
        bottomTextWhenToEdit: '*點擊按鈕可一鍵複製文字、填充圖片',
        forbidden: {
            desc: {
                [FORBIDDEN_TYPE.NOT_APP]: '本次活動需要在APP內查看',
                [FORBIDDEN_TYPE.LOW_VERSION]: '抱歉，需更新APP至最新版本後才能使用'
            },
            btn: {
                [FORBIDDEN_TYPE.LOW_VERSION]: '立即更新'
            }
        }
    },
    [Language.JP]: {
        mycode: 'My紹介コード',
        codeText: '紹介コード',
        copy: 'コピー',
        copySuccess: 'コピー成功',
        shareTo: 'シェア',
        names: {
            [Channel.SYSTEM]: '…',
            [Channel.REDDIT]: 'Reddit',
            [Channel.FACEBOOK]: 'Facebook',
            [Channel.TELEGRAM]: 'Telegram',
            [Channel.XIAOHONGSHU]: '小紅書',
            [Channel.TWITTER]: 'X',
            [Channel.INSTAGRAM]: 'Instagram',
            [Channel.WECHAT]: 'WeChat',
            [Channel.WECHAT_MOMENTS]: 'モーメンツ'
        },
        sharePopupTitle: 'シェアする画像を選ぶ',
        sharePopupImageLabel: '画像選択（1つ）',
        sharePopupImageDownload: '全ての画像をダウンロード',
        sharePopupTextLabel: '文章をコピー',
        sharePopupTextBtn: '他の文章を選ぶ',
        sharePopupFillPrefix: 'コピーしてシェア',
        uninstallPopupDescPrefix: '選択したアプリはお持ちでないようです',
        uninstallPopupShare: '他のアプリを選んでシェアする',
        requestFail: '操作エラー',
        shareTitle: 'SNSで簡単に紹介',
        shareTip: '送るときのコツ',
        shareIconText: '画像と説明文',
        shareBtnText: '{name}で送る',
        disclosure: '開示書類',
        bottomTextWhenToHome: '*テキストをコピーし、画像を保存します',
        bottomTextWhenToEdit: '*テキストをコピーし、画像をアップロードします',
        forbidden: {
            desc: {
                [FORBIDDEN_TYPE.NOT_APP]: 'このプログラムへはアプリからご参加ください',
                [FORBIDDEN_TYPE.LOW_VERSION]: '最新バージョンのアプリで再度お試しください'
            },
            btn: {
                [FORBIDDEN_TYPE.LOW_VERSION]: 'アップデートする'
            }
        }
    }
};

// 当前语种
export const currentLanguage = ref(Language.EN);
// 设置语种
function setCurrentLanguage(language) {
    currentLanguage.value = language;
}

// i18n
const compI18n = computed(() => useI18n(languageMap, currentLanguage.value));

export const _lang = (...args) => compI18n.value(...args);

// 监听语种变化
export function watchLanguage(source) {
    return watch(
        source,
        (value) => {
            setCurrentLanguage(value);
        },
        {
            immediate: true
        }
    );
}
